"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1608],{

/***/ 21608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var Price = function(param) {
    var ListPrice = param.ListPrice, blur = param.blur;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "absolute w-full h-full flex flex-col ".concat(blur ? "blur" : ""),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex-1 flex items-end",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: "text-white bg-primary text-sm rounded-md text-center px-3 py-1 ml-2 mb-2",
                children: [
                    "$",
                    ListPrice.toLocaleString()
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Price);


/***/ })

}]);